import { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { toggleMenu } from "../../actions";

class RouteChange extends PureComponent {
  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      let uri;
      if (nextProps.location.pathname.match(/\/politicus\/(.+)/gm)) {
        uri = "politicus";
      } else if (nextProps.location.pathname.match(/\/code\/(.+)/gm)) {
        uri = "code";
      } else {
        uri = window.location.pathname;
      }
      window.digitalData.page.page_uri = uri;
      window.digitalData.page.trackPageView = "true";

      this.props.closeMenu();
    }
  }

  render() {
    return this.props.children;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeMenu: () => {
      dispatch(toggleMenu(false));
    }
  };
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(RouteChange)
);



// WEBPACK FOOTER //
// ./src/components/HOC/RouteChange.js